import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "searchPanelContainer",
    "title",
    "subtitle",
    "body",
    "footer",
]);
const baseStyle = definePartsStyle({
    searchPanelContainer: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: "2rem",
        background: "semantic.surface.1",
        boxShadow: "medium",
    },
    title: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    },
    subtitle: {
        display: "flex",
        flexDirection: "column",
        pb: "1rem",
    },
    body: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        background: "semantic.surface.1",
    },
    footer: {
        display: "flex",
        columnGap: "1rem",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        pt: "1rem",
    },
});
const SearchPanelTheme = defineMultiStyleConfig({
    baseStyle,
});
export default SearchPanelTheme;
//# sourceMappingURL=SearchPanel.default.js.map